export const amenities_property = {
  /*2: {
    label: "Parcheggio",
    icon: ""
  },*/
}

export function get_amenities_property(key) {
  const amenity = amenities_property[key]
  if (amenity !== undefined) return amenity
  return { label: key, icon: "check_circle",}
}